(function() {

  'use strict';

  function Endereco($rootScope, $http, $q, $filter, API_TOKEN, EnderecoResource, Perfil, localStorageService) {

    var Endereco = {};

    // solicita a lista de endereços
    Endereco.getAddress = function(address, callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      EnderecoResource.getAddress({
          address: address
        }).$promise
        .then(function(data) {
          deferred.resolve(data);
          return cb(data);
        })
        .catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

      return deferred.promise;

    };

    // solicita a lista de endereços
    Endereco.activateAddress = function(idEndereco, callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      EnderecoResource.activateAddress({
          idEndereco: idEndereco
        }).$promise
        .then(function(data) {
          Perfil.getUserData();
          deferred.resolve(data);
          return cb(data);
        })
        .catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

      return deferred.promise;

    };

    // solicita a lista de endereços
    Endereco.deleteAddress = function(idEndereco, callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      EnderecoResource.deleteAddress({
          idEndereco: idEndereco
        }).$promise
        .then(function(data) {
          deferred.resolve(data);
          return cb(data);
        })
        .catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

      return deferred.promise;

    };

    // adiciona endereco e já atualiza ele para ativo
    Endereco.addAddress = function(endereco, area, callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      // atualiza user no LS
      var user = localStorageService.get('user');
      user.dentroDaArea = area;

      localStorageService.set('user', user);

      EnderecoResource.addAddress(endereco).$promise
        .then(function(data) {
          deferred.resolve(data);
          return cb(data);
        })
        .catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

      return deferred.promise;

    };

    // define endereço de devolução
    Endereco.updateReturnAddress = (idEndereco) => EnderecoResource.updateReturnAddress({ idEndereco }).$promise;

    return Endereco;
  }

  angular.module('mandaeApp')
    .factory('Endereco', Endereco);

})();
